import { SITE } from "@/lib/site";

const EVENTS = [
  {
    title: "Weddings",
    image: SITE.images.eventSetup,
    desc: "An elegant espresso bar for cocktail hour, dessert service, or a late-night pick-me-up.",
  },
  {
    title: "Corporate Gatherings",
    image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    desc: "Energize conferences, office mornings, and client events with premium coffee service.",
  },
  {
    title: "Private Parties",
    image: "https://images.unsplash.com/photo-1521017432531-fbd92d768814?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    desc: "Birthdays, showers, holidays, and celebrations of every kind, served with care.",
  },
];

export const EventTypes = () => {
  return (
    <section id="events" data-testid="event-types-section" className="py-24 md:py-32 bg-[#FAF7F2]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-14">
          <p className="uppercase tracking-[0.2em] text-xs font-semibold text-[#8B5E3C] mb-4">
            Where We Serve
          </p>
          <h2 className="font-serif-display text-4xl md:text-5xl font-semibold text-[#2C2621] tracking-tight">
            Perfect for every occasion
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {EVENTS.map((e) => (
            <div
              key={e.title}
              data-testid={`event-card-${e.title.toLowerCase().split(" ")[0]}`}
              className="group relative h-96 rounded-lg overflow-hidden shadow-sm transition-all duration-300 hover:shadow-xl"
            >
              <img
                src={e.image}
                alt={e.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#2C2621]/90 via-[#2C2621]/20 to-transparent" />
              <div className="absolute bottom-0 p-8">
                <h3 className="font-serif-display text-3xl font-semibold text-[#FAF7F2] mb-2">
                  {e.title}
                </h3>
                <p className="text-[#E5DFD3] leading-relaxed">{e.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
